import React, { Component } from 'react';
import { Button, Loading, Modal } from 'carbon-components-react';
import { matchPath } from 'react-router-dom';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { CardLoader, EditableHeader } from '../../../components';
import { UnitsAndStores, Filters, SendDate, Message } from '../../../components/campaigns';
import { getByDmService, insertDmService, updateDmService, errorsHandler } from '../../../services/Api';
import { isCampaignFilterSelected } from '../../../utils';
import campaignSteps from '../../../fixtures/clientCampaignMessages.json';

class EditCampaign extends Component {
  constructor(props) {
    super(props);
    const { match } = this.props;
    
    // Verificar se match existe
    if (!match) {
      console.error('Match prop is undefined');
      this.orderId = null;
      this.state = {
        data: null,
        orderNumber: null,
        isLoading: false,
        isSaving: false,
        successModel: false,
        statusCurrent: null,
        error: 'Não foi possível carregar a campanha'
      };
      return;
    }
    
    const urlVisited = match.path;
    const arrayUrlVisited = urlVisited.split('/');
    const isRequest = arrayUrlVisited[1] === "pedido"; 
    const urlPatch = isRequest ? '/pedido/comunicacao/campanha/:id/informacoes' : '/comunicacao/campanha/:id/informacoes';
    
    // Usar o matchPath com a URL atual
    const updatedMatch = matchPath(match.url, {
      path: urlPatch,
    });
    
    // Verificar se updatedMatch existe antes de acessar params
    if (updatedMatch && updatedMatch.params) {
      this.orderId = updatedMatch.params.id;
    } else {
      console.error('URL não corresponde ao padrão esperado:', match.url, urlPatch);
      this.orderId = null;
    }
    
    this.state = {
      data: null,
      orderNumber: null,
      isLoading: true,
      isSaving: false,
      successModel: false,
      statusCurrent: null,
      error: this.orderId ? null : 'Não foi possível identificar o ID da campanha'
    };
  }

  componentDidMount = async() => {
    // Verificar se orderId existe antes de carregar a campanha
    if (this.orderId) {
      await this.loadCampaign();
    } else {
      this.setState({ isLoading: false });
    }
  }

  loadCampaign = async () => {
    try {
      const data = await getByDmService('/Pedido/GetCampanhaMensagem', this.orderId);
      const showAdminMenuStoraged = localStorage.getItem('showAdminMenu') ? localStorage.getItem('showAdminMenu') === 'true': false;
      const canSave = ([4, 2, 3].indexOf(data.status.id) > -1 ? true : showAdminMenuStoraged)
      const statusCurrent = data.status.nome;
      this.setState({ data, canSave, isLoading: false, statusCurrent });
    } catch (e) {
      console.error('Erro ao carregar campanha:', e);
      toast.error('Ocorreu um erro ao carregar as campanhas');
      this.setState({ data: null, isLoading: false, error: 'Falha ao carregar dados da campanha' });
    }
  };

  saveName = title =>
    updateDmService('/Pedido', this.orderId, {
      descricao: title,
    });

  saveStep = stepData => {
    const { data } = this.state;
    const campaignItem = data.itensCampanhaMensagem;
    this.setState({ isSaving: true });
    if (campaignItem.length) {
      return updateDmService('/Pedido/EditaCampanhaMensagem', campaignItem[0].id, {
        Pedido: this.orderId,
        ...stepData,
      }).then(() => {
        this.loadCampaign();
        this.setState({ isSaving: false });
      });
    }
    return insertDmService('/Pedido/SalvaCampanhaMensagem', {
      Pedido: this.orderId,
      ...stepData,
    }).then(() => {
      this.loadCampaign();
      this.setState({ isSaving: false });
    });
  };

  canFinishOrder = () => {
    const { data } = this.state;
    const campaignItem = data.itensCampanhaMensagem;
    return (
      campaignItem.length &&
      campaignItem[0].salvouUnidades &&
      campaignItem[0].salvouFiltros &&
      campaignItem[0].salvouDatasEnvios &&
      campaignItem[0].salvouMensagem &&
      campaignItem[0].salvouInfoSAC
    );
  };

  saveOrder = async () => {
    const {numero} = this.props;
    this.setState({ isSaving: true });
    try {
      if((numero ? parseInt(numero.replace(/[^0-9]/, ''),10) : 0) > 0) {
        await updateDmService('/Pedido/AtualizaStatus', `${this.orderId}?status=3`);
        this.setState({ orderNumber:numero, isSaving: false });
      } else {
        const orderNumber = await updateDmService('/Pedido/GeraPedido', this.orderId);
        this.setState({ orderNumber, isSaving: false });
      }
      this.toggleSuccessModal();
    } catch (e) {
      errorsHandler(e);
      this.setState({ isSaving: false });
    }
  };

  toggleSuccessModal = () => {
    this.setState(prevState => ({
      successModel: !prevState.successModel,
    }));
  };

  onOrderSuccess = () => {
    this.toggleSuccessModal();
    window.location.href = '/comunicacao/campanhas/criar'
  };

  renderComponent = step => {
    const { data, canSave } = this.state;
    const campaignItem = data.itensCampanhaMensagem.length ? data.itensCampanhaMensagem[0] : {};
    
    switch (step.form) {
      case 'unidades':
        return (
          <UnitsAndStores
            key={step.id}
            showSave={canSave === true}
            disabled={canSave === false}
            step={step}
            campaignItem={campaignItem}
            list={!_.isEmpty(campaignItem) ? campaignItem.unidadesLojas : []}
            saveStep={this.saveStep}
          />
        );
      case 'filtros':
        return (
          <Filters
            key={step.id}
            step={step}
            showSave={canSave === true}
            disabled={canSave === false}
            campaignItem={campaignItem}
            selectedValue={!_.isEmpty(campaignItem) ? isCampaignFilterSelected(campaignItem) : null}
            saveStep={this.saveStep}
            onLoad={() => this.loadCampaign()}
          />
        );
      case 'dataEnvio':
        return (
          <SendDate
            key={step.id}
            step={step}
            showSave={canSave === true}
            disabled={canSave === false}
            campaignItem={campaignItem}
            dates={!_.isEmpty(campaignItem) ? campaignItem.datasEnvio : []}
            saveStep={this.saveStep}
            singleDate
          />
        );
      case 'mensagem':
        return (
          <Message
            key={step.id}
            step={step}
            showSave={canSave === true}
            disabled={canSave === false}
            campaignItem={campaignItem}
            selectedValue={!_.isEmpty(campaignItem) ? campaignItem.mensagem : null}
            saveStep={this.saveStep}
            data={data} // Adicionando data para o componente Message
          />
        );
      case 'sac':
        return (
          <Message
            key={step.id}
            step={step}
            showSave={canSave === true}
            disabled={canSave === false}
            campaignItem={campaignItem}
            selectedValue={!_.isEmpty(campaignItem) ? campaignItem.informacoesSAC : null}
            saveStep={this.saveStep}
            data={data} // Adicionando data para o componente Message
          />
        );
      default:
        return null;
    }
  };

  renderStatus = () => {
    const {statusCurrent} = this.state;
    return (
      <div>
        <h3 className="status-left">
          <span>Status: </span>
          {` ${statusCurrent}`}
        </h3>
      </div>
    );
  }

  renderContent = () => {
    const { data, isLoading, canSave} = this.state;
    if (isLoading) {
      return <CardLoader lines={6} />;
    }
    return (
      <div>
        <EditableHeader renderRigth={this.renderStatus()} showSave={canSave} titleDefault={data.descricao} onSave={this.saveName} />
        {campaignSteps.map(item => this.renderComponent(item))}
      </div>
    );
  };

  render() {
    const { data, orderNumber, isLoading, isSaving, successModel, canSave, error } = this.state;
    const { history, numero } = this.props;
    const nro = (numero ? parseInt(numero.replace(/[^0-9]/, ''),10) : 0);
    
    // Mostrar mensagem de erro se houver
    if (error) {
      return (
        <div className="error-container">
          <h3>Erro</h3>
          <p>{error}</p>
          <Button onClick={() => history.push('/comunicacao/campanhas')}>
            Voltar para Campanhas
          </Button>
        </div>
      );
    }
    
    // Mostrar loading ou conteúdo
    if (isLoading) {
      return <CardLoader lines={6} />;
    }
    
    if (!data) return null;
    
    return (
      <div>
        {this.renderContent()}
        {(!isLoading && canSave) && (
          <div className="v-md-margin">
            <div className="bx--col-xs-12 bx--col-sm-12 v-sm-margin">
              <Button
                className="bx--btn--full-width"
                onClick={this.saveOrder}
                disabled={!this.canFinishOrder()}
              >
                {nro > 0 ? "Enviar alterações" : "Finalizar pedido"}
              </Button>
            </div>
            {nro === 0 && (
              <div className="bx--col-xs-12 bx--col-sm-12 v-sm-margin">
                <Button
                  kind="secondary"
                  className="bx--btn--full-width"
                  onClick={() => history.push('/comunicacao/campanhas/rascunhos')}
                >
                  Terminar depois
                </Button>
              </div>
            )}
          </div>
        )}
        <Modal
          className="bx--modal-secondary-hide"
          open={successModel}
          onRequestSubmit={this.onOrderSuccess}
          modalHeading={nro > 0  ? "Suas alterações foram enviadas para avaliação." : "Pedido feito com sucesso."}
          primaryButtonText="Ok, entendi"
          secondaryButtonText={null}
        >
          <div className="warning-modal-txt">
            <h3>
              {`Seu pedido ${orderNumber} está sob avaliação${nro > 0  ? " e o status foi alterado para pendente" : ""}.`}
            </h3>
            <p className="font-size-13 v-md-margin">
              A qualquer momento você poderá acompanhá-lo clicando em
              {' '}
              <a className="notifications pointer" href="/pedidos">
                <i className="assignment icon-orange" />
              </a>
              {' '}
            </p>
          </div>
        </Modal>
        {isSaving && <Loading small />}
      </div>
    );
  }
}

export default EditCampaign;



// WEBPACK FOOTER //
// ./src/screens/client/campaigns/EditCampaign.js